import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function ActivatingMessage() {
  const { t } = useTranslation('login')

  return (
    <div className="bg-brand-50 border border-brand-200 rounded-lg p-6 text-center">
      <Loader2 className="text-brand-600 size-12 mx-auto mb-4 animate-spin" />
      <h3 className="text-brand-900 font-medium mb-2">
        {t('activate_user.activating.title')}
      </h3>
      <p className="text-brand-700 text-sm">
        {t('activate_user.activating.message')}
      </p>
    </div>
  )
}
